import styled from 'styled-components'

export const Heading = styled('div')`
  margin-bottom: 16px;
  text-align: left;
`
